import React from 'react';

const ADMIN_API_VIEWER_EMAILS = new Set([
    'rhys100@gmail.com',
    'rhys@phaserfpv.com.au'
]);

const normalizeEmail = (email) => String(email || '').trim().toLowerCase();

export default function UserProfileBadge({
    currentUser,
    displayName: displayNameProp,
    onSignOut,
    onAdminApiClick,
    canOpenAdminApi = false
}) {
    if (!currentUser) return null;

    const displayName = displayNameProp
        || currentUser.displayName
        || (currentUser.email ? currentUser.email.split('@')[0] : 'User');
    const initial = displayName.charAt(0).toUpperCase();

    const email = normalizeEmail(currentUser.email);
    const isAdminApiViewer = canOpenAdminApi ||
        ADMIN_API_VIEWER_EMAILS.has(email) ||
        window.location.hostname === 'localhost' ||
        window.location.hostname === '127.0.0.1';

    const openAdminApi = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (onAdminApiClick) onAdminApiClick();
    };

    return (
        <div className="module-header-user-pill">
            {currentUser.photoURL ? (
                <img
                    src={currentUser.photoURL}
                    alt=""
                    className="module-header-user-pill__avatar"
                />
            ) : (
                <div className="module-header-user-pill__initial">
                    {initial}
                </div>
            )}

            {isAdminApiViewer ? (
                <button
                    type="button"
                    onClick={openAdminApi}
                    title="Open API test endpoints"
                    className="module-header-user-pill__identity"
                >
                    <span className="module-header-user-pill__name module-header-user-pill__name--link">
                        {displayName}
                    </span>
                </button>
            ) : (
                <span className="module-header-user-pill__name">{displayName}</span>
            )}

            <button
                type="button"
                onClick={onSignOut}
                className="module-header-user-pill__signout"
                title="Sign out"
                aria-label="Sign out"
            >
                ✕
            </button>
        </div>
    );
}
